/**
 * The site key for an hCaptcha integration. This value is not secret.
 */ export var HCAPTCHA_SITE_KEY = 'HCAPTCHA_SITE_KEY';
